import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import ServiceClass from '../utils/serviceClass';
import {RussianName} from '../utils/names';

import rm_katris from "../js/rm_katris/app";

export default new Vuex.Store({
  state(){
    return{
      jwt: '',
      session: {},
      data: [],
      isLoaded: false,
      courierDataList: [],
      directorDataList: [],
      isError: false,
      errorText: '',
      payerType: '',
      fields: {
        date: '',
        number: '',
        dateString: '',
        dateEnd: '',
        dateEndString: '',
        typeDover: '',
        nameWholesale: '',
        inn: '',
        ogrn: '',
        type: '1',
        fullType: '',
        place: '',
        address: '',
        director: '',
        directorName: '',
        directorRN: '',
        directorNameRN: '',
        directorPol: '',
        directorSer: '',
        directorN: '',
        directorVid: '',
        isOrg: '',
        orgName: '',
        orgAddress: '',
        orgInn: '',
        orgKpp: '',
        courier: '',
        courierRN: '',
        courierName: '',
        courierNameRN: '',
        courierReg: '',
        courierSer: '',
        courierN: '',
        courierVid: '',
        plusDate: 14,
        isMp: true,
      },
    }
  },
  getters: {
    jwt: s => s.jwt,
    session: s => s.session,
    courierDataList: s => s.courierDataList,
    directorDataList: s => s.directorDataList,
    data: s => s.data,
    date: s => s.date,
    fields: s => s.fields,
    isLoaded: s => s.isLoaded,
    isError: s => s.isError,
    errorText: s => s.errorText,
  },
  mutations: {
    setJwt(state, payload) {
      state.jwt = payload;
    },
    setSession(state, payload) {
      state.session = payload;
    },
    setCourier(state, payload){
      state.courierDataList = payload;
    },
    setDirector(state, payload){
      state.directorDataList = payload;
    },
    setData(state, payload) {
      state.data = payload;
    },
    setIsLoaded(state, payload) {
      state.isLoaded = payload;
    },
    setIsError(state, payload) {
      state.isError = payload;
    },
    setErrorText(state, payload) {
      state.errorText = payload;
    },
    setInitialFields(state){
      state.fields = {
        dateString: '',
        inn: '',
        ogrn: '',
        type: '1',
        fullType: '',
        place: '',
        address: '',
        director: '',
        directorName: '',
        directorRN: '',
        directorNameRN: '',
        directorSer: '',
        directorN: '',
        directorVid: '',
        isOrg: '',
        orgName: '',
        orgAddress: '',
        orgInn: '',
        orgKpp: '',
        courier: '',
        courierRN: '',
        courierName: '',
        courierNameRN: '',
        courierReg: '',
        courierSer: '',
        courierN: '',
        courierVid: '',
        plusDate: 14,
        isMp: true,
      }
    },
    setFields(state, payload) {
      state.fields = payload;
    },
    setDateString(state, payload) {
      state.dateString = payload;
    },
  },
  actions: {
    getData({ commit, getters }) {
      this.H = new ServiceClass();
      let courier = localStorage.getItem('courier');
      if(courier){
        courier = JSON.parse(courier);
        commit('setCourier', courier);
      }
      let director = localStorage.getItem('director');
      if(director){
        director = JSON.parse(director);
        commit('setDirector', director);
      }

      rm_katris.params.url = 'https://sale.katris.ru/proxy/';
      rm_katris.params.session = getters.session;
      rm_katris.user = getters.session;

      rm_katris.makePost('katrisService', 'getPayers', {'token': getters.jwt}, null, function(resp) {
        console.log('cont', resp)
        commit('setIsLoaded', true);
        if (resp.status == 'OK') {
          commit('setData', resp.data);
        } else {
          commit('setIsError', true);
          commit('setErrorText', JSON.stringify(resp.errors[0].descr));
        }
      });
    },
    changeFileds({commit, getters}, payload){
      const payloadNames = ['director', 'directorName', 'courier', 'courierName']
      const fields = getters.fields;
      if (payloadNames.includes(payload.key) && payload.val.length > 1) {
        let rn = new RussianName(payload.val);
        fields[payload.key + 'RN'] = rn.fullName(rn.gcaseRod);
      }
      fields[payload.key] = payload.val
      if (payload.key == 'type' || payload.key == 'dateString') {
        console.log(payload.key);
      }
      commit('setFields', fields);
    },
    addEndData({getters}){
      const date = getters.date;
      console.log(date);
    },
    changePayer({commit, getters}, payload){
      if(typeof payload !== 'undefined'){
        const fields = getters.fields;
        for(let key in payload){
          if(typeof fields[key] !== "undefined"){

            fields[key] = payload[key];
            if(key == 'inn' && payload[key].includes('.')){
              fields[key] = "";

            }
          }
        }

        // if(fields.inn.length < 12 && fields.inn.length > 1){
        //   fields.type = 1;
        // }
        // else{
        //   fields.type = 0;
        // }

        if(fields.inn.includes('.')){
          fields.inn = '';
        }

        commit('setFields', fields);
      }
      else{
        commit('setInitialFields');
      }
    },
    changeEndDate({dispatch, getters}){
      const monthArr = {
        0: 'января',
        1: 'февраля',
        2: 'марта',
        3: 'апреля',
        4: 'мая',
        5: 'июня',
        6: 'июля',
        7: 'августа',
        8: 'сентября',
        9: 'октября',
        10: 'ноября',
        11: 'декабря',
      }
      const typeDover = getters.fields.typeDover;
      const date = getters.fields.date;

      if(typeDover && date){
        let plusDate = 14;
        if(typeDover == 'Генеральная доверенность'){
          dispatch('changeFileds', {key: 'dateEndString', val: `«31» декабря ${new Date(date).getFullYear()} г.`});
        }
        else{
          let curdate = new Date(date);
          curdate.setDate(curdate.getDate() + plusDate);
          let endDay = curdate.getDate();
          let endMonth = curdate.getMonth();
          let endYear = curdate.getFullYear();
          if(new Date(date).getFullYear() < endYear){
            dispatch('changeFileds', {key: 'dateEndString', val: `«31» декабря ${new Date(date).getFullYear()} г.`});
          }
          else{
            dispatch('changeFileds', {key: 'dateEndString', val: `«${endDay}» ${monthArr[endMonth]} ${endYear} г.`});

          }
        }
      }
    }
  }
})
